"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _vueTypes = _interopRequireDefault(require("ant-design-vue/es/_util/vue-types"));
var _Modal = require("@/components/Modal");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
// 链接选择器组件
var _default = exports.default = {
  name: 'SelectLink',
  components: {
    LinkModal: _Modal.LinkModal
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    // 选中的链接
    value: _vueTypes.default.object.def({})
  },
  data: function data() {
    return {
      // 已选择的链接
      sLink: null
    };
  },
  watch: {
    value: {
      // 首次加载的时候执行函数
      immediate: true,
      handler: function handler(val) {
        this.onUpdate(val);
      }
    }
  },
  created: function created() {},
  methods: {
    // 更新已选择的数据 sLink
    onUpdate: function onUpdate(sLink) {
      this.sLink = sLink;
      this.onChange();
    },
    // 打开链接选择器
    handleSelectLink: function handleSelectLink() {
      var sLink = this.sLink;
      this.$refs.LinkModal.handle(sLink);
    },
    // 链接选择器确认回调
    handleSubmit: function handleSubmit(result) {
      this.onUpdate(result);
    },
    // 触发change事件
    onChange: function onChange() {
      var sLink = this.sLink;
      return this.$emit('change', sLink);
    }
  }
};